import DlightKenyaDataTable from "./DlightKenyaDataTable";
import * as commonStyles from "styles/Common.module.scss";
import CollapsibleFilterChildren from "./CollapsibleFilterChildren/CollapsibleFilterChildren";
import CollapsibleTopSection from "components/common/CollapsibleTopSection/CollapsibleTopSection";
import CustomLoader from "components/common/CustomLoader/CustomLoader";
import NoDataFound from "components/common/NoDataFound/NoDataFound";
import { toast } from "react-toastify";
import { useInfiniteQuery } from "react-query";
import { useState } from "react";
import { getDlightKenyaDataList } from "common/API/dlightKenyaAPIs";
import DlightKenyaDataSearch from "./DlightKenyaDataSearch";
import { getErrorMessage } from "common/utils/errorUtils";

const DlightKenyaDataList = () => {
  const [searchOptions, setSearchOptions] = useState({});
  const [toggleFilters, setToggleFilters] = useState(false);

  const { isLoading, isError, error, data, fetchNextPage, hasNextPage } =
    useInfiniteQuery(
      ["dlight-kenya-data", searchOptions],
      ({ pageParam = 1 }) =>
        getDlightKenyaDataList({
          pageParam,
          pageSize: 20,
          searchOptions,
        }),
      {
        refetchInterval: Infinity,
      }
    );

  if (isError)
    toast.error(getErrorMessage(error, "Cannot fetch delight kenya data"));

  const dlightKenyaData = data?.pages.flatMap((page) => page.data.results);
  const lastPage = data?.pageParams.at(-1) || 1;
  const noDataFound = !dlightKenyaData || dlightKenyaData?.length === 0;
  return (
    <>
      <CollapsibleTopSection
        {...{
          searchOptions,
          extraChildren: (
            <DlightKenyaDataSearch
              {...{ searchOptions, setSearchOptions, isLoading }}
            />
          ),
          collapsibleFilterChildren: (
            <CollapsibleFilterChildren
              {...{ searchOptions, setSearchOptions }}
            />
          ),
          emptySearchOptionsToConsider: ["product_model", "cpa"],
          toggleFilters,
          setToggleFilters,
        }}
      />
      <DlightKenyaDataTable
        {...{
          fetchNextPage,
          lastPage,
          hasNextPage,
          dlightKenyaData,
          isLoading,
          noDataFound,
          extraClass: noDataFound
            ? ""
            : toggleFilters
            ? "Table_Height3"
            : "Table_Height1",
        }}
      />
      {isLoading && (
        <CustomLoader
          {...{ containerClasses: commonStyles.Table_Body_Loader_Container }}
        />
      )}
      {noDataFound && !isLoading && (
        <NoDataFound
          {...{
            title: "No data found for requested search",
            wrapperClasses: commonStyles.Table_Body_Loader_Container,
          }}
        />
      )}
    </>
  );
};

export default DlightKenyaDataList;
